import { Avatar, IconButton } from "@mui/material";
import React, { useContext, useState } from "react";
import { Box } from "@mui/system";

import { AppContext } from "../../App";
import { no_img } from "../../assets";
import Drawer from "../../layout/Drawer";
import Profile from "./profile/Profile";

const Header = () => {
  const { authUser } = useContext(AppContext);
  const [openProfile, setOpenProfile] = useState(false);

  const handleProfile = () => {
    setOpenProfile(!openProfile);
  };

  return (
    <>
      <Box
        className="flex items-center w-[100%]"
        sx={{ justifyContent: { md: "space-between", xs: "end" } }}
      >
        <Box
          className="ml-[10px] text-gray"
          sx={{
            display: { md: "block", xs: "none" },
          }}
        >
          <img
            className="h-[40px]"
            src={
              authUser && authUser.org && authUser.org.logo
                ? authUser.org.logo
                : no_img
            }
            alt="Logo"
          />
        </Box>
        <div className="flex items-center">
          <div>
            <IconButton
              onClick={handleProfile}
              size="small"
              aria-controls="account-menu"
              aria-haspopup="true"
              aria-expanded="true"
            >
              <Avatar
                alt="profile-pic"
                src={authUser.photo}
                className="bg-primary"
              />
            </IconButton>
          </div>
        </div>
      </Box>

      <Drawer {...{ open: openProfile, setOpen: setOpenProfile }}>
        <Profile {...{ setOpen: setOpenProfile, open: openProfile }} />
      </Drawer>
    </>
  );
};

export default Header;
